import { Card, Typography } from "@mui/material";
import SentDocumentsTab from "views/admin/University/DocumentLibrary/SentDocumentsTab";

/** Cross-college view of every college document sent for signing. */
const CollegeDocumentSends = () => (
  <Card sx={{ p: 2 }}>
    <Typography variant="h5" sx={{ mb: 2 }}>
      College documents sent
    </Typography>
    <SentDocumentsTab />
  </Card>
);

export default CollegeDocumentSends;
